import React from 'react';
import { FormattedNumber } from 'react-intl';
import {
  Stack,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { renderCurrencyField } from '../../../../utils/redux-form-helper';
import { Field } from 'redux-form';
import normalizeProRatedAmount from './normalizeProRatedAmount';
import messages from '../messages';
type Props = {
  monthlyTransaction: Object,
  field: any,
  handleProRatedAmountChange: Function,
  intl: Object,
};

export const ProRatedDetails = ({
  monthlyTransaction,
  field,
  handleProRatedAmountChange,
  intl,
}: Props): any => {
  return (
    <tr>
      <td>
        <Stack direction="row" alignItems="center" justifyContent="center">
          {monthlyTransaction?.code}
          {monthlyTransaction?.code === 'UTILREIMBADJ' && (
            <Tooltip
              placement="right"
              title={intl.formatMessage(messages.utilReimbAdjTooltip)}
            >
              <AlertInfoIcon fontSize="small" sx={{ ml: 0.5 }} />
            </Tooltip>
          )}
        </Stack>
      </td>
      <td>{monthlyTransaction.description}</td>
      <td>{monthlyTransaction.name}</td>
      <td>
        <FormattedNumber
          value={monthlyTransaction.amount}
          style={{ value: 'currency' }.value}
          currency="USD"
        />
      </td>
      <td>
        <Field
          name={`${field}.proratedAmount`}
          component={renderCurrencyField}
          className="text-right"
          min="0"
          max="9999"
          precision={2}
          step="0.01"
          normalize={normalizeProRatedAmount}
          disabled={true}
        />
      </td>
    </tr>
  );
};
